// ===== Packages =====

import {
    getFunctions,
    httpsCallable,
}                                   from 'firebase/functions';

// ===== Services =====

import getCurrentActionOrigin       from './getCurrentActionOrigin';

// ===== Interfaces =====

import type {
    ISendVerifyAccountEmailInput,
    ISendVerifyAccountEmailPayload,
    ISendVerifyAccountEmailResult,
}                                   from '../interfaces';

// ===== Enums =====
import {
    SEND_VERIFY_ACCOUNT_EMAIL_STATUS,
}                                   from '../enums';

const sendVerifyAccountEmail = async ({
    test,
}: ISendVerifyAccountEmailInput): Promise<ISendVerifyAccountEmailResult> => {
    const functions = getFunctions();
    const handleSendVerifyAccountEmail = httpsCallable<
        ISendVerifyAccountEmailPayload,
        boolean | ISendVerifyAccountEmailResult
    >(
        functions,
        'sendVerifyAccountEmail',
    );
    const actionOrigin = getCurrentActionOrigin();
    const payload: ISendVerifyAccountEmailPayload = {
        test,
    };
    if (actionOrigin) payload.actionOrigin = actionOrigin;
    return handleSendVerifyAccountEmail(payload).then((result) => {
        if (typeof result.data === 'boolean') {
            return {
                success: result.data,
                status: result.data
                    ? SEND_VERIFY_ACCOUNT_EMAIL_STATUS.sent
                    : SEND_VERIFY_ACCOUNT_EMAIL_STATUS.failed,
            };
        }
        return result.data as ISendVerifyAccountEmailResult;
    }).catch((err) => {
        throw err;
    });
};

export default sendVerifyAccountEmail;
